<template>
  <div
    :class="`d-flex lead-bottom-control-panel
    ${theme.isDark ? 'lead-bottom-control-panel_dark' : ''} 
    ${
      call && online
        ? 'lead-bottom-control-panel_show'
        : 'lead-bottom-control-panel_hide'
    }`"
  >
    <CallControll />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CallControll from "@/components/twillio/CallControll";

export default {
  name: "BottomPanel",
  inject: ["theme"],
  props: {},
  components: {
    CallControll,
  },
  computed: {
    ...mapGetters({
      call: "twilio/call",
      isGuide: "auth/isGuide",
      online: "auth/online",
    }),
  },
};
</script>

<style lang="scss">
.lead-bottom-control-panel {
  position: fixed;
  margin: 0;
  padding: 0;
  list-style: none;
  height: 80px;
  bottom: 0;
  left: 56px;
  right: 0;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  background-color: white;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);

  &_show {
    height: 80px !important;
  }

  &_hide {
    height: 0 !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }

  &_dark {
    background-color: #272727;
  }
}
</style>
